import { DUPE_API_URL } from '@dupe/common/constants'
import { useQuery } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'
import { UpdateUserPayload } from '~/src/types'

interface UseFetchUserProps {
  includeResultCounts?: boolean
}

/**
 * Hook to fetch detailed user data
 * This replaces the direct API call in AuthProvider
 */
const useFetchUser = (props?: UseFetchUserProps) => {
  const { includeResultCounts = false } = props || {}
  const { authUser } = useAuthUser()

  return useQuery<{ user: UpdateUserPayload }>({
    queryKey: ['user-data', authUser?.uid, includeResultCounts],
    queryFn: async () => {
      const userData = await fetcher<{ user: UpdateUserPayload }>(
        `${DUPE_API_URL}/api/user?includeResultCounts=${includeResultCounts}`,
        {
          method: 'GET',
          authUser,
        }
      )

      return userData
    },
    enabled: !!authUser?.uid,
  })
}

export default useFetchUser
